'use client';

import { Details } from '@ria-client/tw-shared-ui';
import { ChevronDown } from 'lucide-react';
import { useId, useState, type ReactNode } from 'react';

export interface AccordionItemDetailsProps {
  children: ReactNode;
  label: string;
  initialStateExpanded?: boolean;
}

export function AccordionItemDetails({
  children,
  label,
  initialStateExpanded,
}: AccordionItemDetailsProps) {
  const panelId = `accordion-content-${useId()}`;
  const [isExpanded, setIsExpanded] = useState(initialStateExpanded ?? false);

  return (
    <li className="[&:last-of-type_details]:border-b [&:last-of-type_details]:border-border">
      <Details
        variant="simple"
        className="border-t border-border bg-inherit"
        detailsProps={{
          open: isExpanded,
          onToggle: event => setIsExpanded(event.currentTarget.open),
        }}
        SummaryComponent={
          <>
            <span className="typography-text-bold">{label}</span>
            <ChevronDown aria-hidden className="expand-icon size-5 opacity-[0.54]" />
          </>
        }
        summaryComponentProps={{
          className:
            'flex items-center justify-between px-2 py-3 hover:bg-secondary sm:hover:outline-2 sm:hover:outline-[var(--content-blue-focus-outline)]',
          'aria-controls': panelId,
          'aria-expanded': isExpanded,
          onKeyDown: event => {
            if (event.key !== 'Enter') return;

            event.preventDefault();
            event.currentTarget.click();
          },
        }}
      >
        <div id={panelId} className="p-4">
          {children}
        </div>
      </Details>
    </li>
  );
}
